import React, { useEffect, useState } from "react";
import Input from "../../ui/Input/Input";
import { toast } from "react-toastify";
import Button from "../../ui/Button/Button";
import Title from "../../ui/Title/Title";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import AvitoIcon from "../../assets/icons/AvitoIcon";
import styles from "./ModalAvitoIntegrationForm.module.scss";
import {
  setActiveTg,
  setNewBot,
  setNewTg,
} from "../../store/slices/integrationSlice";
import { setNewAvito } from "../../store/slices/avitoSlice";
import { useModal } from "../../context/ModalContext";
import { useLocation, useNavigate } from "react-router-dom";
import {
  stepsDataAvitoClientId,
  stepsDataAvitoClientSecret,
} from "../../assets/consts/tooltipDataAvito";
import { Modal } from "../../ui/Modal/Modal";
import {
  getAvitoIntegration,
  getAvitoIntegrations,
  initAvito,
} from "../../utils/api/actions/integrations/avito";

const SuccessInitAvito = ({ closeModal, closeAddIntegrationModal }) => {
  const [countdown, setCountdown] = useState(5); // Начальный таймер на 5 секунд
  const dispatch = useDispatch();
  const location = useLocation();

  const externalId = location.pathname.split("/").pop();
  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    // Устанавливаем интервал для обратного отсчета
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Закрываем сообщение после завершения обратного отсчета
    if (countdown === 0) {
      closeModal();
      closeAddIntegrationModal();
      dispatch(getAvitoIntegrations(id));
      if (location.pathname.split("/").length > 3) {
        dispatch(getAvitoIntegration(id, externalId));
      }
      dispatch(setActiveTg(null));
      dispatch(setNewTg(null));
      dispatch(setNewBot(null));
      dispatch(setNewAvito(null));
    }

    // Очищаем интервал при размонтировании компонента или завершении обратного отсчета
    return () => clearInterval(timer);
  }, [
    countdown,
    closeModal,
    dispatch,
    closeAddIntegrationModal,
    externalId,
    id,
    location.pathname,
  ]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили Avito!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

export const ModalAvitoIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data);
  const { isLoading, isConnected } = useSelector((state) => state?.avito);

  const errorMessage = () =>
    toast.error("Avito не был привязан!", {
      toastId: "customId",
    });

  const [valueClientId, setValueClientId] = useState("");
  const [valueSecretId, setValueSecretId] = useState("");
  const [errors, setErrors] = useState({ clientId: "", secretId: "" });

  const handleSendData = () => {
    const data = {
      userId: user?.id || "",
      clientId: valueClientId.trim(),
      clientSecret: valueSecretId.trim(),
    };

    dispatch(initAvito(data, errorMessage, navigate));
    // console.log("Отправляемые данные:", data);
  };

  const validateInputs = () => {
    const newErrors = {
      clientId: valueClientId.trim() ? "" : "Поле не может быть пустым",
      secretId: valueSecretId.trim() ? "" : "Поле не может быть пустым",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handlerInput = (e) => {
    const { name, value } = e.target;
    if (name === "clientId") setValueClientId(value);
    if (name === "clientSecret") setValueSecretId(value);
  };

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      clientId: valueClientId.trim() ? "" : "Поле не может быть пустым",
      secretId: valueSecretId.trim() ? "" : "Поле не может быть пустым",
    }));
  }, [valueClientId, valueSecretId]);

  const hintClientId = {
    id: "clientId",
    stepsData: stepsDataAvitoClientId,
  };

  const hintClientSecret = {
    id: "clientId",
    stepsData: stepsDataAvitoClientSecret,
  };

  return (
    <Modal visible={visible} handleClose={handlerClose}>
      <div className={styles.layout}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <AvitoIcon />
        </div>

        {!isConnected ? (
          <div className={styles.content}>
            <div className={styles.inputGroup}>
              <div className={styles.inputContainer}>
                <Input
                  className={styles.child}
                  name="clientId"
                  label="ID клиента"
                  labelStyle={styles.labelInput}
                  backgroundStyle={styles.labelBackground}
                  inputStyle={`${styles.input}`}
                  value={valueClientId}
                  placeholder={"Id"}
                  type={"text"}
                  onChange={handlerInput}
                  hint={hintClientId}
                />
                {errors.clientId && (
                  <span className={styles.errorText}>{errors.clientId}</span>
                )}
              </div>
            </div>
            <div className={styles.inputGroup}>
              <div className={styles.inputContainer}>
                <Input
                  className={styles.child}
                  name="clientSecret"
                  label="Секретный ключ"
                  labelStyle={styles.labelInput}
                  backgroundStyle={styles.labelBackground}
                  inputStyle={`${styles.input}`}
                  value={valueSecretId}
                  placeholder={"Ключ"}
                  type={"text"}
                  onChange={handlerInput}
                  hint={hintClientSecret}
                />
                {errors.secretId && (
                  <span className={styles.errorText}>{errors.secretId}</span>
                )}
              </div>
            </div>
            <Button
              title="Отправить"
              onClick={() => (validateInputs() ? handleSendData() : undefined)}
              className={styles.nextButton}
              titleClassName={styles.nextButtonTitle}
              leftIcon={
                isLoading ? <ClipLoader size={20} color="white" /> : null
              }
            />
          </div>
        ) : (
          <SuccessInitAvito
            closeModal={handlerClose}
            closeAddIntegrationModal={closeModal}
          />
        )}
      </div>
    </Modal>
  );
};
